import { SendHorizontal } from 'lucide-react';
import { cn } from '../../lib/utils';
import DotsSpinner from '../common/dots-spinner';
import { Input } from '../ui/input';
import { isMobile } from 'react-device-detect';
const ChatbotBottom = ({ newMessage, setNewMessage, handleSendMessage, sendMessageLoading, aiReplyLoading }) => {

  // useEffect(() => {
  //   const textarea = document.getElementById('messageInput');
  //   if (textarea) {
  //     textarea.focus();
  //   }
  // }, []);

  return (
    <div>
      {/* <div className='border-t'> */}
      {/* <div className='w-full flex justify-between items-center overflow-x-auto gap-2 scrollbar-thin p-3'>
        {chatConfigurationStyle?.faqs?.map((faq, index) =>
          <span key={index} onClick={() => handleSendMessage(faq)} style={{ background: chatConfigurationStyle?.messageColor }} className='cursor-pointer text-sm text-nowrap block py-1.5 px-3 rounded-sm w-fit'>{faq?.question}</span>
        )}
      </div> */}

      <div className={cn('flex justify-between items-center px-3 pb-4 pt-3 bg-white rounded-b-lg', isMobile && "rounded-none")}>
        <Input
          value={newMessage}
          onChange={(e) => setNewMessage(e?.target?.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();  // Prevents creating a new line
              if (newMessage?.trim()) {
                handleSendMessage();  // Call your send function
              }
            }
          }}
          placeholder="Write a message..."
          className="w-full mr-2 h-11 rounded-sm bg-accent border-none"
          id="messageInput"
        />
        {
          sendMessageLoading ? <DotsSpinner /> :
            <SendHorizontal onClick={() => { (newMessage?.trim() && !aiReplyLoading) && handleSendMessage() }} className={cn('cursor-pointer w-6 h-6', (!newMessage?.trim() || aiReplyLoading || sendMessageLoading) && "text-muted-foreground cursor-not-allowed")} />
        }
      </div>
    </div>
  )
}

export default ChatbotBottom